import { AUTH } from "../constants/actionTypes";
import * as api from "../api/index.js";
import { message } from "antd";

export const signin = (formData, history, setLoading) => async (dispatch) => {
  try {
    const { data } = await api.signIn(formData);
    dispatch({ type: AUTH, data });

    if (data.store && data.storeStatus === "ACTIVE") {
      if (data.role === "ADMIN" || data.role === "SUPER_ADMIN") {
        setLoading(false);
        history("/dashboard");
        window.location.reload(true);
        message.success("Sign In successfully");
      } else {
        message.error("You have no access of this portal. You are not admin");
        setLoading(false);
      }
    } else {
      setLoading(false);
      message.error(
        "Your store is disabled Now! Please contact admin to enable this."
      );
    }
  } catch (error) {
    if (error) {
      setLoading(false);
      console.log(error);
      message.error(
        error?.response?.data?.message
          ? error?.response?.data?.message
          : "Network Error"
      );
    }
  }
};

export const signup = (formData, history, setLoading) => async (dispatch) => {
  try {
    const { data } = await api.signUp(formData);
    dispatch({ type: AUTH, data });
    if (data) {
      setLoading(false);
      history("/createStore");
      window.location.reload(true);
      message.success("Account created successfully!");
    }
  } catch (error) {
    if (error) {
      setLoading(false);
      console.log(error?.response?.data?.message);
      message.error(
        error?.response?.data?.message
          ? error?.response?.data?.message
          : "Network Error"
      );
    }
  }
};
